import { Alert, Chip, Grid, Stack, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import { ClientPortalContext } from '../../ClientPortal'
import { TenantSettingsContext } from '../../../../../App'

const OutstandingInvoices = () => {
  const { organisation } = useContext(ClientPortalContext)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  return (
    <Grid item xs={12} md={6} lg={4}>
      <Stack gap={1}>
        <Typography variant="title2">Outstanding Invoices</Typography>
        {organisation?.unpaidInvoices?.length === 0 ? (
          <Alert
            severity="success"
            variant="outlined"
            sx={{ borderColor: '#00964C' }}
          >
            All caught up!
          </Alert>
        ) : (
          <Stack gap={1}>
            {organisation?.unpaidInvoices?.map((invoice) => {
              const totalOutstanding = () => {
                const totalItems = invoice.items.reduce((accumulator, item) => {
                  let itemTotal = item.quantity * item.unitPrice
                  if (item.vat === '0.2') itemTotal += itemTotal * 0.2
                  accumulator += itemTotal
                  return accumulator
                }, 0)
                const paymentTotals = invoice.payments.reduce(
                  (accumulator, payment) => {
                    accumulator += payment.amount
                    return accumulator
                  },
                  0,
                )
                return totalItems - paymentTotals
              }
              return (
                <Grid
                  key={invoice._id}
                  container
                  paddingX={1}
                  paddingY={1.5}
                  sx={{ cursor: 'pointer' }}
                  border="solid 1px"
                  borderColor="anMainBlue.main"
                  borderRadius={1}
                >
                  <Grid item xs={12} md={8}>
                    {invoice?.event?.title ?? invoice?.reference}
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Chip
                      size="small"
                      label={`${orgSettings?.currency ?? '£'}${totalOutstanding()}`}
                      sx={{ borderRadius: 1, width: '100%' }}
                      color="anOrange"
                    />
                  </Grid>
                </Grid>
              )
            })}
          </Stack>
        )}
      </Stack>
    </Grid>
  )
}

export default OutstandingInvoices
